<template>
    <div class="content">
        <div class="notification is-warning">{{ $t('empty') }}</div>
        <br>
    </div>
</template>

<script>
import { i18nMixin } from "@/vue/mixins/i18nMixin";

export default {
    name: 'notFound',
    mixins: [
        i18nMixin
    ]
}
</script>

<style lang="scss" scoped>

</style>

<i18n>
{
    "en": {
        "pageTitle": "Not found",
        "empty": "Not found"
    },
    "fi": {
        "pageTitle": "Sivua ei löytynyt",
        "empty": "Sivua ei löytynyt"
    }
}
</i18n>
